import * as React from 'react';
import { useState, useEffect } from 'react';
import styles from './assistantGroupDetail.module.scss';
import commissioner from '../../static/images_pfizer/commissioner.png';
import volunteer from '../../static/images_pfizer/volunteer.png';
import nurse from '../../static/images_pfizer/nurse.png';
import { withRouter } from 'react-router-dom';
import { ApiCore } from '../../api/index';
import utils from '../../utils/utils';
const api = new ApiCore();

const TeamDetail = (props: any) => {

    const [assistantInfo, setAssistantInfo] = useState<any>({});
    const [groupInfo, setGroupInfo] = useState<any>([]);

    useEffect(() => {
        window.document.title = '医助详情';
        getData();
    }, [])

    const getData = () => {
        const urlParams = utils.getUrlParams();
        if (urlParams.assistantCode) {
            api.getAssistantDetail(urlParams.assistantCode).then((res: any) => {
                if (res.code == 0) {
                    setAssistantInfo(res.data);
                }
            });
            api.getGroupAssist({
                assistantCode: urlParams.assistantCode
            }).then((res: any) => {
                if (res.code == 0) {
                    setGroupInfo(res.data);
                }
            });
        }
    }

    return (
        <div className={styles.assistantGroupDetail_content}>

            <div className={styles.assistant_list}>
                <div className={styles.assistant_content}>
                    <img className={styles.avatar} src={assistantInfo.type == 'VOLUNTEER' ? volunteer : assistantInfo.type == 'NURSE' ? nurse : commissioner} alt="" />
                    <div className={styles.content}>
                        <div className={styles.userInfo}>
                            <div className={styles.info}>
                                <span className={styles.name}>{assistantInfo.name}</span>
                                {
                                    assistantInfo.type == 'VOLUNTEER' ? <span className={styles.volunteer}>志愿者</span> :
                                    assistantInfo.type == 'NURSE' ? <span className={styles.nurse}>护士</span> :
                                            <span className={styles.occupation}>随访专员</span>
                                }

                            </div>
                            <span className={styles.phone}></span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.assistant_info}>
                <div className={styles.assistant_info_title}>
                    <div></div><div>助理信息</div>
                </div>
                <div className={styles.info_item}>
                    <div>性别</div>
                    <div>{assistantInfo.sex == 0 ? '女' : '男'}</div>
                </div>
                <div className={styles.info_item}>
                    <div>省份</div>
                    <div>{assistantInfo.province}</div>
                </div>
                <div className={styles.info_item}>
                    <div>城市</div>
                    <div>{assistantInfo.city}</div>
                </div>
                <div className={styles.info_item}>
                    <div>加入时间</div>
                    <div>
                        {
                            assistantInfo.createTime ? assistantInfo.createTime.slice(0, 10) : ''
                        }
                    </div>
                </div>
            </div>

            <div className={styles.apply_project}>
                <div className={styles.assistant_info_title}>
                    <div></div><div>协管项目</div>
                </div>
                {
                    groupInfo && groupInfo.map((val: any, key: number) => (
                        <div key={key} className={styles.apply_project_content}>
                            <div>
                                {
                                    val.groupName
                                }
                            </div>
                            <div>
                                {
                                    val.remark
                                }
                            </div>
                        </div>
                    ))
                }
            </div>

        </div>
    )
}

export default withRouter(TeamDetail);